import React, { useContext } from 'react';

import SubscriptionList from './SubscriptionList.jsx';
import Button from './Button.jsx';

import TranslationsContext from '../TranslationsContext';

export default function ConfigurationStep({
	subscriptionProducts,
	subscriptionsDetails,
	depositedData,
	setDepositedData,
	currentDog,
	subscriptionDisplay,
	setSubscriptionsDetails,
	step,
	setStep,
	setWidgetError,
	navigate,
	formatMoney,
}) {
	const t = useContext(TranslationsContext);

	return (
		<>
			<SubscriptionList
				subscriptionProducts={subscriptionProducts}
				subscriptionsDetails={subscriptionsDetails}
				depositedData={depositedData}
				setDepositedData={setDepositedData}
				currentDog={currentDog}
				subscriptionDisplay={subscriptionDisplay}
				setSubscriptionsDetails={setSubscriptionsDetails}
				formatMoney={formatMoney}
			/>
			<div className=" subscriptions-configurator__buttons-wrapper column small-12 flex-container flex-dir-row align-spaced section-spacing-padding">
				<Button
					type="button"
					action={step - 1}
					setStep={(nextStep) => {
						setDepositedData((prevState) => {
							prevState[currentDog] = {
								...prevState[currentDog],
								subscription: {},
							};
							return prevState;
						});
						const newSubscriptionsDetails = subscriptionsDetails.map((el) => {
							el.selected = false;
							return el;
						});
						setSubscriptionsDetails([...newSubscriptionsDetails]);
						setWidgetError('');
						window.scrollTo({ top: 0, behavior: 'smooth' });
						navigate('/pages/subscriptions/details');
						setStep(nextStep);
					}}
					text={t('back')}
					classname="button button--border-green white"
				/>
				<Button
					type="button"
					action={step + 1}
					setStep={(nextStep) => {
						if (depositedData[currentDog].subscription === '' || Object.keys(depositedData[currentDog].subscription).length === 0) {
							setWidgetError(t('error_select_subscription'));
						} else {
							setWidgetError('');
							window.scrollTo({ top: 0, behavior: 'smooth' });
							navigate('/pages/subscriptions/summary');
							setStep(nextStep);
						}
					}}
					text={t('next')}
					classname="button button--gradient-green"
				/>
			</div>
		</>
	);
}
